export var frequencyLabelId = function (frequency) {
    return "ui-br-legaldeposits.periodicals.frequency.".concat(frequency);
};
